var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.4","d":"M8.55455 0C3.82771 0 0 3.77005 0 8.41528C0 13.0605 3.82771 16.8306 8.55455 16.8306C13.29 16.8306 17.1262 13.0605 17.1262 8.41528C17.1262 3.77005 13.29 0 8.55455 0ZM8.56312 15.1475C4.77822 15.1475 1.71262 12.1348 1.71262 8.41528C1.71262 4.69573 4.77822 1.68306 8.56312 1.68306C12.348 1.68306 15.4136 4.69573 15.4136 8.41528C15.4136 12.1348 12.348 15.1475 8.56312 15.1475ZM8.99127 4.20764H7.70681V9.25681L12.2024 11.9076L12.8447 10.8725L8.99127 8.62566V4.20764Z","fill":"#50606C"}));
}

Clock.defaultProps = {"width":"17.13","height":"17","viewBox":"0 0 17.13 17"};

module.exports = Clock;

Clock.default = Clock;
